//
// FieldpickerMetadata
//
// Based on view info from a layout

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../stores'

import { Icon, Item } from '../../../../components'
import { formatItemTitle } from '../../../../stores/data/utils'
import { ItemTitle } from '../../../components'

export const FieldpickerMetadata = observer(function FieldpickerMetadata({
    className,
    name,
    field,
    value,
    language,
    component,
    renderkey,
    worksheet,
}) {
    const { data, view } = useStore()

    let attributes = { className: 'layout-component ws-fieldpicker' }
    if (className) attributes['className'] += ' ' + className
    if (component.style) attributes['className'] += ' lc-' + component.style

    const linkedfieldgids = value ? value.split(/\./) : []
    const linkedfields = linkedfieldgids.map(gid =>
        data.fields.has(gid) ? data.fields.get(gid) : undefined
    )

    const subfieldtitles = linkedfields.map((subfield, index) => {
        const title = subfield
            ? formatItemTitle(
                  subfield,
                  view.language,
                  view.environment.get('labelView')
              )
            : undefined
        if (!title) {
            return null
        }
        return (
            <Item key={index} indent={2 * index}>
                <Icon name="field" size="text" />{' '}
                <ItemTitle item={subfield} ellipsisAfter={32} />
            </Item>
        )
    })

    return <div {...attributes}>{subfieldtitles}</div>
})
